import { MessageSquare, Play } from 'lucide-react'

interface Props {
  mode: 'inputs' | 'manual'
  errorSummary: string | null
  blockedReason?: string
}

export function ChainPauseUnresolvedBanner({ mode, errorSummary, blockedReason }: Props) {
  const isManual = mode === 'manual'
  const Icon = isManual ? Play : MessageSquare
  const title = isManual ? 'Awaiting manual start' : 'Awaiting inputs'

  return (
    <div className="rounded-lg border border-warning-foreground bg-warning p-4" data-testid="chain-pause-unresolved-banner" role="alert">
      <div className="space-y-3">
        <div className="flex items-center gap-2 font-semibold text-warning-foreground">
          <Icon className="h-4 w-4" />
          {title}
        </div>

        <p className="text-sm text-warning-foreground">
          This chain is paused, but the link it waits on could not be matched to any of the links below.
        </p>

        {errorSummary && (
          <div>
            <p className="text-xs font-medium text-warning-foreground mb-1">Error summary</p>
            <p className="text-sm text-warning-foreground">{errorSummary}</p>
          </div>
        )}

        {blockedReason && (
          <p className="text-sm text-warning-foreground" data-testid="chain-unresolved-blocked-reason">
            {blockedReason}
          </p>
        )}
      </div>
    </div>
  )
}
